export default __webpack_public_path__ + "static/Donald.Curry_social-0a2c91cd89dced54210a3d149727f12b.jpg";